/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormAuditUpdateResponseDto } from '../../models/form-audit-update-response-dto';

export interface Forms$Params {
  body: Array<string>;
}

export function forms(
  http: HttpClient,
  rootUrl: string,
  params: Forms$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<FormAuditUpdateResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, forms.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FormAuditUpdateResponseDto>>;
    })
  );
}

forms.PATH = '/auditing/reopen/forms';
